import React, {useState } from 'react';
import deshboard from '../../images/deshboard.png';
import { Link } from 'react-router-dom';
const ProjectSection = (props) => {
        const [activeFilter, setActiveFilter] = useState('dashboard');

        const handleFilterClick = (filter) => {
            setActiveFilter(filter);
        }


    return (
        <section className="portfolio_section xb-hidden section_space">
            <div className="container">
                <div className="heading_block">
                    <div className="row">
                        <div className="col-lg-12">
                            <h4 className="text-center mb-0">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            </h4>
                        </div>

                        <div className='col-md-12'>
                                <div className="filter_elements_nav">
                                    <ul className="unordered_list justify-content-center">
                                        <li className={activeFilter === 'dashboard' ? 'active' : ''} onClick={() => handleFilterClick('dashboard')}>Dashboard</li>
                                        <li className={activeFilter === 'mEmployee' ? 'active' : ''} onClick={() => handleFilterClick('mEmployee')}>Manage Employee</li>
                                        <li className={activeFilter === 'iOrders' ? 'active' : ''} onClick={() => handleFilterClick('iOrders')}>Inventory Orders</li>
                                        <li className={activeFilter === 'mProperty' ? 'active' : ''} onClick={() => handleFilterClick('mProperty')}>Manage Property</li>
                                        <li className={activeFilter === 'mBooking' ? 'active' : ''} onClick={() => handleFilterClick('mBooking')}>Manage Booking</li>
                                        <li className={activeFilter === 'mKOT' ? 'active' : ''} onClick={() => handleFilterClick('mKOT')}>Manage KOT</li>
                                    </ul>
                                </div>
                                <div className={`filter_elements_wrapper row ${activeFilter === 'dashboard' ? 'show_div' : 'hide_div'}`}>
                                    <div className='col-lg-4'>
                                        <div>
                                            <h2>Heading</h2>
                                            <p>All-in-one software that helps you.</p>
                                            <Link to="/pricing"><b>Explore more</b></Link>
                                        </div>
                                    </div>
                                    <div className='col-lg-8'>
                                        <img src={deshboard} alt="Mobile App Design"  style={{width:'100%'}}/>
                                    </div>
                                </div>

                                <div className={`filter_elements_wrapper row ${activeFilter === 'mEmployee' ? 'show_div' : 'hide_div'}`}>
                                    <div className='col-lg-4'>
                                        <div>
                                            <h2>Heading MEmployee</h2>
                                            <p>All-in-one software that helps you.</p>
                                            <Link to="/pricing"><b>Explore more</b></Link>
                                        </div>
                                    </div>
                                    <div className='col-lg-8'>
                                        <img src={deshboard} alt="Mobile App Design"  style={{width:'100%'}}/>
                                    </div>
                                </div>

                                
                        </div>
                    </div>
                </div>
            </div>
            
        </section>
    );
}

export default ProjectSection;